import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import Cards from '../Cards';
import Introduction from '../Introduction';
import FeaturedProjects from './FeaturedProjects';
import JoinTeam from './JoinTeam';

function Home() {
  return (
    <>
      <HeroSection />
      <Introduction />
      <FeaturedProjects />
      <JoinTeam />

      <Footer />

    </>
  );
}

export default Home;
